import {
  Box,
  Button,
  Col,
  Divider,
  Flex,
  Grid,
  Group,
  List,
  Menu,
  Modal,
  NumberInput,
  Select,
  Text,
  TextInput,
  Badge,
  Alert,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { 
  IconTag, 
  IconCrown, 
  IconInfoCircle, 
  IconGift,
  IconDiscount2,
} from "@tabler/icons";
import { coupons_api } from "pages/master/coupons/coupons.service";
import { api_addCustomer, api_getCustomers } from "pages/master/customers/customers.service";
import { getAlteredCustomers } from "pages/master/customers/helperFunctions";
import React, { useState, useEffect } from "react";
import { useMutation, useQuery } from "react-query";
import { showErrorToast, showSuccessToast } from "utilities/Toast";

export default function CouponsModal(props) {
  const [coupons, setCoupons] = useState([]);
  const [availableCoupons, setAvailableCoupons] = useState([]);

  const [referralCoupons, setReferralCoupons] = useState([]);
  
  const coupons_data = useQuery("coupons", coupons_api.get, {
    onSuccess: data => setCoupons(data.data),
  });
  // Fetch referral coupons for the customer
  const fetchReferralCoupons = async () => {
    if (!props.customerId) return;
    
    try {
      const response = await coupons_api.referralCouponsGet({
        user_id: props.customerId,
        // source: 'referral'
      });
      const data = (response?.data || []).filter(coupon =>
  !coupon.used &&
  (!coupon.expiry_date || new Date() <= new Date(coupon.expiry_date))
);

      // console.log(response)
      setReferralCoupons(data || []);
    } catch (error) {
      console.error('Error fetching referral coupons:', error);
      setReferralCoupons([]);
    }
  };
  // Combine regular coupons with customer's yearly coupon
  useEffect(() => {
    if (coupons && Array.isArray(coupons)) {
      let allCoupons = [...coupons];

      console.log("coupon model props", props)
      
      // Check if we have customer's yearly coupon data from props
      if (props.customerYearlyCouponStatus && props.customerYearlyCouponStatus.active === true ) {
        const isYearlyCouponAlreadyInList = allCoupons.some(
          coupon => coupon.coupon_code === props.yearlyCouponCode
        );
        
        // If yearly coupon is not already in the list, add it
        if (!isYearlyCouponAlreadyInList) {
          // Calculate the required purchase amount: cutoff_amount + 100 rupees
          const baseCutoffAmount = props.customerYearlyCouponStatus?.cutt_off_amount || 
                                  props.customerYearlyCouponStatus?.cutoff_amount || 
                                  0;
          
          const yearlyCoupon = {
            id: `yearly_${props.customerId || 'customer'}`,
            coupon_code: props.yearlyCouponCode,
            coupon_name: "Yearly Reward Coupon",
            coupon_type: "Yearly",
            value: props.customerYearlyCouponStatus?.coupon_amount || 0,
            cutoff_amount: baseCutoffAmount, // Store the base cutoff amount
            required_purchase_amount: props.customerYearlyCouponStatus?.coupon_amount + 100, // Purchase must be 100 rupees greater
            active: props.customerYearlyCouponStatus?.active || false,
            // Custom properties for identification
            is_customer_specific: true,
            customer_id: props.customerId,
            month_count: props.customerYearlyCouponStatus?.month_count || 0,
            customer_name: props.customerName || "Customer",
            note: `Purchase must be ₹100 greater than cutoff (₹${baseCutoffAmount})`
          };
          
          // Add yearly coupon to the beginning of the list
          allCoupons.unshift(yearlyCoupon);
        }
      }
      // Add referral coupons
    if (props.customerId && referralCoupons && referralCoupons.length > 0) {
      const formattedReferralCoupons = referralCoupons
      .filter(referral => referral.used === false)
      .map(referral => ({
        id: `referral_${referral.id || referral.code || 'coupon'}`,
        coupon_code: referral.code || referral.coupon_code || '',
        coupon_name: referral.source == 'welcome' ? "Welcome Coupon" : "Referral Coupon",
        coupon_type: referral.source,
        value: referral.discount_amount || 0,
        discount_type: referral.discount_type || 'amount',
        min_purchase: referral.min_purchase || 0,
        cutoff_amount: referral.min_purchase || 0,
        required_purchase_amount: referral.min_purchase || 0,
        active: referral.active !== undefined ? referral.active : (referral.used === false),
        isReferral: true,
        source: 'referral',
        discount_amount: referral.discount_amount,
        expiry_date: referral.expiry_date,
        used: referral.used || false,
        user_name: referral.user_name
      }));
      allCoupons = [...formattedReferralCoupons, ...allCoupons];
    }
      setAvailableCoupons(allCoupons);
    }
  }, [coupons, props.customerYearlyCouponStatus, props.yearlyCouponCode, props.customerId, props.customerName, referralCoupons]);

    // Fetch referral coupons when customer changes
  useEffect(() => {
    if (props.customerId) {
      fetchReferralCoupons();
    } else {
      setReferralCoupons([]);
    }
  }, [props.customerId]);

  const handleCouponClick = (coupon) => {
    // Check if this is a referral coupon
    const isReferralCoupon = coupon.isReferral || coupon.source === "referral";
  
    
    if (isReferralCoupon) {
      // For referral coupons
      if (props.setReferralCouponCode) {
        props.setReferralCouponCode(coupon.coupon_code);
       
      } else {
        props.setCouponCode({ coupon_code:  coupon.coupon_code });
     
      }
    } else {
      // For regular/yearly coupons
    props.setCouponCode({ coupon_code: coupon.coupon_code });
  }
 
  // Close modal
  props.setModalOpened(false);
  
  // Show success message
  showSuccessToast({
    title: "Coupon Selected",
    message: `Coupon "${ coupon.coupon_code}" has been selected.`
  });
};

    // Get coupon value display
  const getCouponValueDisplay = (coupon) => {
    const isReferralCoupon = coupon.isReferral || coupon.source === 'referral';
  
  if (isReferralCoupon) {
    if (coupon.discount_type === 'percentage') {
      return `${coupon.discount_amount}%`;
    } else {
      return `₹${coupon.discount_amount}`;
    }
  }
      // For regular coupons
  if (coupon.coupon_type === "flat") {
    return `${coupon.value}%`;
  } else if (coupon.coupon_type === "yearly") {
    return `₹${coupon.value}`;
  } else {
    return `₹${coupon.value}`;
  }
};


  // Get coupon requirement display
  const getCouponRequirementDisplay = (coupon) => {
    const isReferralCoupon = coupon.isReferral || coupon.source === 'referral';
  
  if (isReferralCoupon) {
    if (coupon.min_purchase > 0) {
      return (
        <Group spacing={4}>
          <Text size="xs" color="dimmed">
            • Min Purchase: <Text span fw={600}>₹{coupon.min_purchase}</Text>
          </Text>
        </Group>
      );
    }
    return null;
  }
   if (coupon.is_customer_specific && coupon.required_purchase_amount) {
      // For yearly coupons: Must purchase 100 rupees MORE than cutoff
      return (
        <Group spacing={4}>
          <Text size="xs" color="dimmed">
            • Min Purchase: <Text span fw={600}>₹{coupon.required_purchase_amount.toFixed(2)}</Text>
          </Text> 
        </Group>
      );
    } else if (coupon.cutoff_amount > 0) {
      // For regular coupons: Must purchase AT LEAST the cutoff amount
      return (
        <Text size="xs" color="dimmed">
          • Min Purchase:<Text span fw={600}> ₹{coupon.cutoff_amount.toFixed(2)}</Text>
        </Text>
      );
    }
    return null;
  };

// Get coupon badge
  const getCouponBadge = (coupon) => {
      const isReferralCoupon = coupon.isReferral || coupon.source === 'referral';
  
  if (isReferralCoupon) {
    return (
      <Badge color="green" size="xs" ml={5}>
        Referral
      </Badge>
    );
  }
  
  // For yearly coupons
   if (coupon.is_customer_specific) {
      const qualifies = props.customerYearlyCouponStatus?.active === true && 
                       props.customerYearlyCouponStatus?.month_count >= 11;
      
      if (qualifies) {
        return (
          <Badge color="green" size="xs" ml={5}>
            Eligible
          </Badge>
        );
      } else {
        return (
          <Badge color="yellow" size="xs" ml={5}>
            {props.customerYearlyCouponStatus?.month_count || 0}/11 months
          </Badge>
        );
      }
    }
    
    if (coupon.coupon_type === "Yearly") {
      return (
        <Badge color="blue" size="xs" ml={5}>
          Yearly
        </Badge>
      );
    }
    
    return null;
  };

  return (
    <Modal
      opened={props.modalOpened}
      onClose={() => {
        props.setModalOpened(false);
      }}
      title={
        <Box px={10}>
          <Group spacing="xs">
            <IconTag size={20} />
            <Text fw={600}>Available Coupons</Text>
          </Group>
          {props.customerName && (
            <Text size="sm" color="dimmed" mt={5}>
              Customer: {props.customerName}
              {props.customerYearlyCouponStatus && (
                <Text span size="sm" color="orange" ml={10}>
                  • Yearly Progress: {props.customerYearlyCouponStatus?.month_count || 0}/11 months
                </Text>
              )}
            </Text>
          )}
        </Box>
      }
      size={"800px"}
      centered
    >
      <Box px={10}>
        <Divider mb={20} />
        
        {availableCoupons.length === 0 ? (
          <Alert icon={<IconInfoCircle size={16} />} color="blue">
            No coupons available at the moment.
          </Alert>
        ) : (
          <Box>
            {availableCoupons.map((coupon, index) => {
              const isYearlyCoupon = coupon.coupon_type === "Yearly" || coupon.is_customer_specific;
              const isCustomerSpecific = coupon.is_customer_specific;
              const isReferralCoupon = coupon.isReferral || coupon.source === 'referral';
              
              return (
                <Box key={index} mb={15}>
                  <Flex
                    direction="row"
                    justify="space-between"
                    align="center"
                    p={5}
                    sx={(theme) => ({
                      border: `1px solid ${
                      isReferralCoupon
                      ? theme.colors.green[5]
                        :isCustomerSpecific 
                          ? theme.colors.yellow[5] 
                          : isYearlyCoupon 
                            ? theme.colors.blue[5] 
                            : theme.colors.gray[3]
                      }`,
                      borderRadius: theme.radius.md,
                      backgroundColor: isReferralCoupon
                    ? theme.fn.rgba(theme.colors.green[0], 0.3)
                    : isCustomerSpecific 
                        ? theme.fn.rgba(theme.colors.yellow[0], 0.3)
                        : isYearlyCoupon
                          ? theme.fn.rgba(theme.colors.blue[0], 0.2)
                          : theme.colors.gray[0],
                    })}
                  >
                    <Box style={{ flex: 1 }}>
                      <Group spacing="xs" mb={3}>
                        <Text fw={600} size="sm">
                          { coupon.coupon_code}
                        </Text>
                        {getCouponBadge(coupon)}
                        {isCustomerSpecific && (
                          <IconCrown size={14} color="#FFD700" />
                        )}
                      </Group>
                      
                      <Text size="sm" mb={3}>
                        {coupon.coupon_name || coupon.description || `${coupon.coupon_type} Coupon`}
                      </Text>
                      
                      <Group spacing="xs" mb={3}>
                        <Text size="xs" color="dimmed">
                          Value: {getCouponValueDisplay(coupon)}
                        </Text>
                        
                        {getCouponRequirementDisplay(coupon)}
                      </Group>
                    </Box>
                    
                    <Button
                      variant={isReferralCoupon ? "filled" :isCustomerSpecific ? "filled" : "filled"}
                      color={isReferralCoupon ? "green" :isCustomerSpecific ? "yellow" : "blue"}
                      size="xs"
                      onClick={() => handleCouponClick(coupon)}
                      disabled={isCustomerSpecific && !props.customerQualifiesForYearlyCoupon}
                      title={isCustomerSpecific && !props.customerQualifiesForYearlyCoupon ? 
                        "Customer does not qualify for yearly coupon yet" : 
                        isCustomerSpecific && coupon.required_purchase_amount ? 
                        `Apply this coupon (Purchase must be ₹${coupon.required_purchase_amount.toFixed(2)})` :
                        "Apply this coupon"}
                    >
                      Select
                    </Button>
                  </Flex>
                  
                  {index < availableCoupons.length - 1 && <Divider mb={15} />}
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Modal>
  );
}